import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from "@material-ui/core/CssBaseline";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import HomePage from "./pages/HomePage";
import NavBar from './components/NavBar';
import AdminPage from './pages/AdminPage';
import theme, { brand } from './theme';

function App() {
  let location = useLocation();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {location.pathname === '/admin' ? null : <NavBar />}
        <Switch>
          <Route exact path="/">
            <HomePage />
          </Route>
          <Route path="/admin">
            <AdminPage />
          </Route>
        </Switch>
      </Router>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: brand.ink,
            color: '#FFFFFF',
            fontWeight: 500,
            borderRadius: 2,
            padding: '12px 16px',
          },
          success: {
            iconTheme: { primary: brand.accent, secondary: '#FFFFFF' },
          },
        }}
      />
    </ThemeProvider>
  );
}

export default App;
